import { render } from "./ProjectsItemNav.vue?vue&type=template&id=2ba846c8"
import script from "./ProjectsItemNav.vue?vue&type=script&lang=js"
export * from "./ProjectsItemNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__